import React from "react";

import { Container, IconContainer, Title, TotalValue, GraficBarContainer, GraficBarBackground, GraficBarContent, PercentText, PostScritumContainer, PostScritum } from "./styles";

//Interface
import { EstablishmentGraficBarPropsInterface } from "./interfaces";

import moment from "moment";

const EstablishGraficBar = (props: EstablishmentGraficBarPropsInterface) => {
    const colors = [
        {
            title: "Aprovados",
            color: "#F58B1E"
        },
        {
            title: "Cancelados",
            color: "#F46B45"
        },
        // {
        //     title: "Pendentes",
        //     color: "#FFCD8B"}
    ]
    
    const graficBarGenerator = () => {
        return colors.map((grafic, index) => {
            return (
                <div key={index} style={{marginBottom: 12}}>
                    <Title>{grafic.title}</Title>
                    <div className="d-flex align-items-center">
                        <GraficBarBackground>
                            <GraficBarContent color={grafic.color} width={`${percentIndicator(grafic.title)}%`}/>
                            <span className="tooltiptext">R$ {grafic.title === "Aprovados" 
                                ? isNaN(props.approvedSum as number) ? "0" : props.approvedSum?.toLocaleString("pt-BR") 
                                : isNaN(props.canceledSum as number) ? "0" : props.canceledSum?.toLocaleString("pt-BR") }
                            </span>
                        </GraficBarBackground>
                        <PercentText>
                            {percentIndicator(grafic.title)?.toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}%
                        </PercentText>
                    </div>
                </div>
            )
        })
    }

    const percentIndicator = (title: string) => {
        switch (title) {
            case "Aprovados":
                return isNaN(props.approved) ? 0 : props.approved;
            
            case "Cancelados":
                return isNaN(props.canceled) ? 0 : props.canceled;
            
            case "Pendentes":
                return isNaN(props.pendent) ? 0 : props.pendent;
            
            default:
                return 0;
        }
    }
    
    return(
        <Container>
            <div className="d-flex">
                <IconContainer>
                    <img src={props.icon} style={{width: 15}}/>
                </IconContainer>
                <div className="d-flex align-items-center">
                    <div>
                        <Title>{props.title}</Title>
                        <TotalValue>R$ {isNaN(props.value) ? "0" : props.value.toLocaleString("pt-BR")}</TotalValue>
                    </div>
                </div>
            </div>

            <GraficBarContainer>
                {graficBarGenerator()}
            </GraficBarContainer>
            
            <PostScritumContainer>
                <PostScritum>{`*Última atualização ${moment( ).format("DD/MM/YYYY hh:mm")}`}</PostScritum>
            </PostScritumContainer>
        </Container>
    )
}

export default EstablishGraficBar;
